if (process.env.NODE_ENV === 'production') {
  module.exports = require('./vue.common.prod.js')
} else {
  module.exports = require('./vue.common.dev.js')
}



//////////////////
// WEBPACK FOOTER
// F:/Solutions/7572bo/master/~/vue/dist/vue.common.js
// module id = 15
// module chunks = 1